export default __webpack_public_path__ + "static/media/k2.d5e7b48b.svg";